import { CreateUserPayloadForm } from "@/services/merchantUser/type";
import { createFormContext } from "@mantine/form";

export const [UserFormProvider, useUserFormContext, useUserForm] =
  createFormContext<CreateUserPayloadForm>();
